import { graphql, useStaticQuery } from 'gatsby';

import isDefined from '../utils/isDefined';
import * as FeatureFlag from '../types/feature-flag';

const useFeatureFlags = () => {
  const { allFeatureFlag } = useStaticQuery<FeatureFlag.Query>(
    graphql`
      {
        allFeatureFlag {
          edges {
            node {
              description
              isActive
              lastFetched
              modifiedDate
              name
              variations {
                T_A
                T_B
                T_C
                T_D
              }
            }
          }
        }
      }
    `,
  );

  const { edges } = allFeatureFlag;
  const featureFlags = edges
    .filter(isDefined)
    .map(edge => edge.node)
    .reduce((allFlags, flag) => {
      const { name } = flag;
      if (name) {
        allFlags.set(name, flag);
      }
      return allFlags;
    }, new Map<string, FeatureFlag.Base>());
  return featureFlags;
};

export default useFeatureFlags;
